import styled, { css } from 'styled-components';
import { breakpointsMedia } from '@nubank/nuds-web/styles/breakpoints';

import Block from 'components/structure/Block/Block';

export const StyledBlock = styled(Block)`
  ${breakpointsMedia({
    md: css`
      width: 100%;
    `,
    lg: css`
      width: 50%;
    `,
  })}
`;

StyledBlock.displayName = 'StyledBlock';
